module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("23YYl"))).then(() => parcelRequire('fThBo'));